import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import webImage1 from "./../Images/webImage1.png";
import Image1 from "./../Images/Image1.png";
import Image2 from "./../Images/Image2.png";
import Image3 from "./../Images/Image3.png";
import Image4 from "./../Images/Image4.png";

// ─── Inline SVG Icons (zero external dependencies) ───────────────────────────
const ic = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const IconCalendar = ({ s = 22 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="16" y1="2" x2="16" y2="6" />
  </svg>
);
const IconUsers = ({ s = 22 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <circle cx="9" cy="8" r="4" />
    <circle cx="17" cy="8" r="3" />
    <path d="M1 20c0-3.9 3.6-7 8-7s8 3.1 8 7" />
    <path d="M17 14c2.2 0 5 1.1 5 4v2" />
  </svg>
);
const IconBarChart = ({ s = 22 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <polyline points="4,20 4,4" />
    <line x1="4" y1="20" x2="20" y2="20" />
    <rect x="6" y="12" width="3" height="8" />
    <rect x="11" y="7" width="3" height="13" />
    <rect x="16" y="4" width="3" height="16" />
  </svg>
);
const IconClock = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="12,7 12,12 15,15" />
  </svg>
);
const IconCheck = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="8,12 11,15 16,9" />
  </svg>
);
const IconZap = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" />
  </svg>
);
const IconTrend = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <polyline points="22,7 13.5,15.5 8.5,10.5 2,17" />
    <polyline points="16,7 22,7 22,13" />
  </svg>
);
const IconArrow = ({ s = 16 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="13,6 19,12 13,18" />
  </svg>
);
const IconMenu = ({ s = 24 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);
const IconClose = ({ s = 24 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const IconGlobe = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <circle cx="12" cy="12" r="9" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <path d="M12 3a14.5 14.5 0 010 18M12 3a14.5 14.5 0 000 18" />
  </svg>
);
const IconDownload = ({ s = 16 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7,10 12,15 17,10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const IconPhone = ({ s = 20 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.12 1.2 2 2 0 012.11 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
  </svg>
);
const IconSMS = ({ s = 20 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
  </svg>
);
const IconTick = ({ s = 14 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" {...ic}>
    <polyline points="6,12 10,16 18,8" />
  </svg>
);

const IconWhatsApp = ({ s = 22 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);
const IconInstagram = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);
const IconFacebook = ({ s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);
const IconGooglePlay = ({ s = 17 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="white">
    <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85A1.5 1.5 0 013 20.5z" />
    <path d="M16.81 15.12L6.05 21.34l8.49-8.49 2.27 2.27z" />
    <path d="M20.16 10.81a1.5 1.5 0 010 2.38l-2.27 1.31-2.5-2.5 2.5-2.5 2.27 1.31z" />
    <path d="M6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z" />
  </svg>
);
const IconApple = ({ s = 17 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="white">
    <path d="M18.71 19.5c-.88 1.24-1.77 2.45-3.11 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.19-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.37 2.83zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);
// ─────────────────────────────────────────────────────────────────────────────

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --sky: #38bdf8;
    --sky-dark: #0ea5e9;
    --sky-deep: #0284c7;
    --sky-light: #bae6fd;
    --sky-pale: #f0f9ff;
    --ink: #0c1a2e;
    --ink2: #1e3a5f;
    --muted: #64748b;
    --border: #e2e8f0;
    --white: #ffffff;
  }
  .lp { font-family: 'Plus Jakarta Sans', -apple-system, sans-serif; background: var(--white); color: var(--ink); min-height: 100vh; overflow-x: hidden; }

  /* NAV */
  .lp__nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; display: flex; justify-content: space-between; align-items: center; padding: 0.9rem 2.5rem; background: var(--white); border-bottom: 1px solid var(--border); transition: box-shadow 0.3s; }
  .lp__nav--scrolled { box-shadow: 0 4px 20px rgba(12,26,46,0.08); }
  .lp__logo { font-weight: 800; font-size: 1.5rem; letter-spacing: -0.03em; color: var(--ink); text-decoration: none; }
  .lp__logo span { color: var(--sky); }
  .lp__nav-links { display: flex; gap: 2rem; list-style: none; align-items: center; }
  .lp__nav-links a { font-size: 0.83rem; font-weight: 500; color: var(--muted); text-decoration: none; transition: color 0.2s; }
  .lp__nav-links a:hover { color: var(--sky-dark); }
  .lp__nav-right { display: flex; align-items: center; gap: 1rem; }
  .lp__social-btn { display: flex; align-items: center; color: var(--muted); transition: color 0.2s; text-decoration: none; }
  .lp__social-btn:hover { color: var(--sky-dark); }
  .lp__lang-wrap { position: relative; }
  .lp__lang-btn { display: flex; align-items: center; gap: 0.4rem; font-size: 0.78rem; font-weight: 600; color: var(--muted); background: transparent; border: 1.5px solid var(--border); padding: 0.45rem 0.9rem; border-radius: 8px; cursor: pointer; transition: border-color 0.2s, color 0.2s; }
  .lp__lang-btn:hover { border-color: var(--sky); color: var(--ink); }
  .lp__lang-drop { position: absolute; right: 0; top: calc(100% + 6px); background: var(--white); border: 1px solid var(--border); border-radius: 10px; min-width: 160px; z-index: 200; box-shadow: 0 8px 24px rgba(12,26,46,0.1); overflow: hidden; }
  .lp__lang-opt { display: flex; align-items: center; gap: 0.6rem; width: 100%; padding: 0.65rem 1rem; font-size: 0.82rem; font-weight: 500; color: var(--ink); background: transparent; border: none; cursor: pointer; transition: background 0.15s; text-align: left; }
  .lp__lang-opt:hover { background: var(--sky-pale); }
  .lp__lang-opt--active { background: var(--sky-pale); color: var(--sky-dark); font-weight: 700; }
  .lp__nav-cta { font-size: 0.8rem; font-weight: 700; background: var(--sky); color: var(--ink); border: none; padding: 0.6rem 1.4rem; border-radius: 8px; cursor: pointer; transition: background 0.2s; }
  .lp__nav-cta:hover { background: var(--sky-dark); color: var(--white); }
  .lp__hamburger { display: none; background: transparent; border: none; color: var(--ink); cursor: pointer; padding: 0.25rem; }

  /* MOBILE MENU */
  .lp__mobile-menu { display: none; position: fixed; top: 61px; left: 0; right: 0; background: var(--white); border-bottom: 1px solid var(--border); padding: 1.25rem 2rem 1.75rem; z-index: 99; flex-direction: column; gap: 0; box-shadow: 0 8px 24px rgba(12,26,46,0.08); }
  .lp__mobile-menu--open { display: flex; }
  .lp__mobile-menu a { font-size: 0.88rem; font-weight: 500; color: var(--muted); text-decoration: none; padding: 0.75rem 0; border-bottom: 1px solid var(--border); transition: color 0.2s; }
  .lp__mobile-menu a:hover { color: var(--sky-dark); }
  .lp__mobile-lang-label { font-size: 0.65rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--muted); margin: 1rem 0 0.6rem; }
  .lp__mobile-lang-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.5rem; margin-bottom: 1rem; }
  .lp__mobile-lang-btn { display: flex; flex-direction: column; align-items: center; gap: 0.3rem; padding: 0.65rem; border: 1.5px solid var(--border); border-radius: 8px; background: transparent; cursor: pointer; font-size: 0.7rem; font-weight: 600; color: var(--muted); transition: all 0.2s; }
  .lp__mobile-lang-btn--active { border-color: var(--sky); background: var(--sky-pale); color: var(--sky-dark); }
  .lp__mobile-cta { font-size: 0.82rem; font-weight: 700; background: var(--sky); color: var(--ink); border: none; padding: 0.85rem; border-radius: 8px; cursor: pointer; }

  /* MODAL */
  .lp__modal-overlay { position: fixed; inset: 0; z-index: 300; display: flex; align-items: center; justify-content: center; background: rgba(12,26,46,0.6); padding: 1.5rem; }
  .lp__modal { background: var(--white); border-radius: 16px; max-width: 400px; width: 100%; padding: 2.5rem; box-shadow: 0 24px 64px rgba(12,26,46,0.2); animation: modalUp 0.3s ease-out; }
  @keyframes modalUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  .lp__modal-icon { width: 3.25rem; height: 3.25rem; background: var(--sky-pale); border-radius: 12px; display: flex; align-items: center; justify-content: center; color: var(--sky-dark); margin: 0 auto 1.25rem; }
  .lp__modal-title { font-size: 1.5rem; font-weight: 800; text-align: center; color: var(--ink); margin-bottom: 0.4rem; letter-spacing: -0.025em; }
  .lp__modal-sub { font-size: 0.85rem; color: var(--muted); text-align: center; margin-bottom: 1.75rem; }
  .lp__modal-opts { display: flex; flex-direction: column; gap: 0.6rem; }
  .lp__modal-opt { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 0.85rem 1.1rem; border: 1.5px solid var(--border); border-radius: 10px; background: transparent; cursor: pointer; font-size: 0.95rem; font-weight: 600; color: var(--ink); transition: all 0.2s; }
  .lp__modal-opt:hover { border-color: var(--sky); background: var(--sky-pale); }
  .lp__modal-opt-left { display: flex; align-items: center; gap: 0.75rem; }
  .lp__modal-hint { font-size: 0.72rem; color: var(--muted); text-align: center; margin-top: 1.25rem; }

  /* MARQUEE */
  .lp__marquee { background: var(--sky-pale); border-top: 1px solid var(--sky-light); border-bottom: 1px solid var(--sky-light); padding: 0.65rem 0; overflow: hidden; }
  .lp__mq-inner { display: flex; gap: 2.5rem; white-space: nowrap; animation: mqScroll 22s linear infinite; }
  .lp__mq-inner span { font-size: 0.7rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--sky-dark); }
  .lp__mq-inner span::before { content: '● '; font-size: 0.4rem; vertical-align: middle; margin-right: 0.3rem; }
  @keyframes mqScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  /* HERO */
  .lp__hero { display: grid; grid-template-columns: 1fr 360px; min-height: 520px; margin-top: 61px; }
  .lp__hero-left { padding: 4rem 3rem; display: flex; flex-direction: column; justify-content: center; gap: 1.5rem; }
  .lp__badge { display: inline-flex; align-items: center; gap: 0.5rem; background: var(--sky-pale); border: 1px solid var(--sky-light); border-radius: 999px; padding: 0.35rem 1rem; font-size: 0.73rem; font-weight: 700; color: var(--sky-dark); width: fit-content; }
  .lp__badge-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--sky); animation: pulseDot 1.8s infinite; flex-shrink: 0; }
  @keyframes pulseDot { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:.5; transform:scale(1.4); } }
  .lp__h1 { font-size: clamp(2.4rem, 4vw, 3.6rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.035em; color: var(--ink); }
  .lp__h1 span { color: var(--sky); }
  .lp__hero-desc { font-size: 1rem; color: var(--muted); line-height: 1.75; max-width: 480px; }
  .lp__hero-btns { display: flex; gap: 0.75rem; flex-wrap: wrap; }
  .lp__btn-main { display: inline-flex; align-items: center; gap: 0.45rem; font-size: 0.82rem; font-weight: 700; background: var(--sky); color: var(--ink); border: none; padding: 0.9rem 2rem; border-radius: 10px; cursor: pointer; transition: background 0.2s; }
  .lp__btn-main:hover { background: var(--sky-dark); color: var(--white); }
  .lp__btn-ghost { font-size: 0.82rem; font-weight: 600; background: transparent; color: var(--ink2); border: 1.5px solid var(--border); padding: 0.9rem 1.75rem; border-radius: 10px; cursor: pointer; transition: border-color 0.2s; }
  .lp__btn-ghost:hover { border-color: var(--sky); }
  .lp__hero-stats { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background: var(--border); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
  .lp__stat-cell { background: var(--white); padding: 1rem 1.25rem; }
  .lp__stat-num { font-size: 1.8rem; font-weight: 800; color: var(--sky-dark); letter-spacing: -0.03em; line-height: 1; }
  .lp__stat-lbl { font-size: 0.72rem; font-weight: 500; color: var(--muted); margin-top: 0.2rem; }

  /* HERO RIGHT */
  .lp__hero-right { background: var(--sky); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1.5rem; padding: 3rem 2rem; }
  .lp__hero-right-label { font-size: 0.68rem; font-weight: 700; letter-spacing: 0.15em; text-transform: uppercase; color: var(--ink2); opacity: 0.7; }
  .lp__phone-sm { width: 158px; height: 308px; background: var(--ink); border-radius: 2rem; padding: 1rem 0.85rem; display: flex; flex-direction: column; gap: 0.55rem; border: 3px solid rgba(255,255,255,0.25); animation: phoneFloat 4s ease-in-out infinite; position: relative; overflow: hidden; }
  @keyframes phoneFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-14px); } }
  .lp__p-notch { width: 36px; height: 5px; background: var(--ink2); border-radius: 3px; align-self: center; margin-bottom: 0.3rem; flex-shrink: 0; }
  .lp__store-pills { display: flex; flex-direction: column; gap: 0.65rem; width: 100%; }
  .lp__store-pill { display: flex; align-items: center; gap: 0.65rem; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.4); border-radius: 8px; padding: 0.65rem 1rem; text-decoration: none; transition: background 0.2s; }
  .lp__store-pill:hover { background: rgba(255,255,255,0.35); }
  .lp__store-pill-icon { width: 26px; height: 26px; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .lp__store-pill p { font-size: 0.52rem; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(12,26,46,0.6); }
  .lp__store-pill strong { font-size: 0.8rem; font-weight: 700; color: var(--ink); display: block; }

  /* FEATURES */
  .lp__features-section { padding: 5rem 3rem; text-align: center; }
  .lp__section-label { font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase; color: var(--sky-dark); margin-bottom: 0.75rem; }
  .lp__h2 { font-size: clamp(1.9rem, 3vw, 2.5rem); font-weight: 800; line-height: 1.15; letter-spacing: -0.03em; color: var(--ink); margin-bottom: 1rem; }
  .lp__h2 span { color: var(--sky); }
  .lp__section-sub { font-size: 0.97rem; color: var(--muted); line-height: 1.72; max-width: 560px; margin: 0 auto; }
  .lp__feat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; margin-top: 3rem; }
  .lp__feat-card { background: var(--white); border: 1px solid var(--border); border-radius: 14px; padding: 2rem 1.75rem; text-align: left; transition: border-color 0.25s, transform 0.25s; cursor: default; }
  .lp__feat-card:hover, .lp__feat-card--active { border-color: var(--sky); transform: translateY(-4px); }
  .lp__feat-icon-box { width: 48px; height: 48px; background: var(--sky-pale); border-radius: 10px; display: flex; align-items: center; justify-content: center; color: var(--sky-dark); margin-bottom: 1.25rem; }
  .lp__feat-title { font-size: 1.05rem; font-weight: 700; color: var(--ink); margin-bottom: 0.5rem; }
  .lp__feat-desc { font-size: 0.88rem; color: var(--muted); line-height: 1.65; }
  .lp__feat-stat { margin-top: 1.25rem; font-size: 0.72rem; font-weight: 700; color: var(--sky-dark); background: var(--sky-pale); border-radius: 6px; display: inline-block; padding: 0.3rem 0.75rem; }

  /* APP SECTION */
  .lp__app-section { background: var(--sky-pale); border-top: 1px solid var(--sky-light); border-bottom: 1px solid var(--sky-light); }
  .lp__app-inner { display: grid; grid-template-columns: 1fr 400px; align-items: center; gap: 4rem; padding: 5rem 3rem; }
  .lp__app-body { font-size: 0.97rem; color: var(--muted); line-height: 1.72; margin-bottom: 1.75rem; }
  .lp__app-feat-list { display: flex; flex-direction: column; }
  .lp__app-feat-row { display: flex; align-items: flex-start; gap: 1rem; padding: 1.1rem 0; border-bottom: 1px solid var(--border); }
  .lp__app-feat-row:last-child { border-bottom: none; }
  .lp__app-feat-dot { width: 32px; height: 32px; min-width: 32px; background: var(--sky); border-radius: 8px; display: flex; align-items: center; justify-content: center; color: var(--ink); margin-top: 2px; flex-shrink: 0; }
  .lp__app-feat-title { font-size: 0.95rem; font-weight: 700; color: var(--ink); margin-bottom: 0.2rem; }
  .lp__app-feat-desc { font-size: 0.85rem; color: var(--muted); line-height: 1.58; }
  .lp__app-right { display: flex; flex-direction: column; align-items: center; gap: 1.5rem; }
  .lp__phone-lg { width: 200px; height: 390px; background: var(--ink); border-radius: 2.5rem; padding: 1.25rem 1rem; display: flex; flex-direction: column; gap: 0.6rem; border: 3px solid var(--ink2); animation: phoneFloat 4s ease-in-out infinite; position: relative; overflow: hidden; }
  .lp__dl-btns { display: flex; flex-direction: column; gap: 0.75rem; width: 100%; }
  .lp__dl-btn { display: flex; align-items: center; gap: 0.75rem; background: var(--white); border: 1.5px solid var(--border); border-radius: 10px; padding: 0.75rem 1.1rem; text-decoration: none; transition: border-color 0.2s; }
  .lp__dl-btn:hover { border-color: var(--sky); }
  .lp__dl-icon { width: 30px; height: 30px; border-radius: 7px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .lp__dl-btn p { font-size: 0.55rem; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: var(--muted); }
  .lp__dl-btn strong { font-size: 0.8rem; font-weight: 700; color: var(--ink); display: block; }

  /* GALLERY */
  .lp__gallery { padding: 0 3rem 4rem; }
  .lp__gallery-title { font-size: 1.2rem; font-weight: 700; text-align: center; color: var(--ink); margin-bottom: 1.75rem; }
  .lp__gallery-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; }
  .lp__gallery-item { aspect-ratio: 9/16; border-radius: 12px; overflow: hidden; border: 1px solid var(--border); transition: transform 0.3s; }
  .lp__gallery-item:hover { transform: translateY(-4px); }
  .lp__gallery-item img { width: 100%; height: 100%; object-fit: cover; display: block; }

  /* BENEFITS + DASHBOARD */
  .lp__dash-section { display: grid; grid-template-columns: 1fr 1fr; border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); }
  .lp__dash-left { padding: 5rem 3rem; border-right: 1px solid var(--border); }
  .lp__dash-right { padding: 5rem 3rem; background: var(--sky-pale); }
  .lp__bene-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-top: 2rem; }
  .lp__bene-card { background: var(--white); border: 1px solid var(--border); border-radius: 12px; padding: 1.4rem; transition: border-color 0.25s; }
  .lp__bene-card:hover { border-color: var(--sky); }
  .lp__bene-icon { width: 38px; height: 38px; background: var(--sky-pale); border-radius: 8px; display: flex; align-items: center; justify-content: center; color: var(--sky-dark); margin-bottom: 0.9rem; }
  .lp__bene-title { font-size: 0.95rem; font-weight: 700; color: var(--ink); margin-bottom: 0.35rem; }
  .lp__bene-desc { font-size: 0.83rem; color: var(--muted); line-height: 1.58; }
  .lp__dash-card { background: var(--white); border: 1px solid var(--border); border-radius: 14px; overflow: hidden; margin-top: 1.5rem; }
  .lp__dash-row { display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.4rem; border-bottom: 1px solid var(--border); }
  .lp__dash-row:last-child { border-bottom: none; }
  .lp__dash-lbl { font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--muted); }
  .lp__dash-val { font-size: 1.4rem; font-weight: 800; color: var(--ink); letter-spacing: -0.02em; }
  .lp__dash-val--sky { color: var(--sky-dark); }
  .lp__dash-val--green { color: #059669; }
  .lp__dash-badge { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; background: var(--sky-pale); color: var(--sky-dark); border: 1px solid var(--sky-light); border-radius: 999px; padding: 0.2rem 0.65rem; }

  /* CONTACT */
  .lp__contact-section { display: grid; grid-template-columns: repeat(3, 1fr); border-bottom: 1px solid var(--border); }
  .lp__contact-col { padding: 2.5rem; border-right: 1px solid var(--border); transition: background 0.25s; text-decoration: none; color: inherit; display: block; }
  .lp__contact-col:last-child { border-right: none; }
  .lp__contact-col:hover { background: var(--sky-pale); }
  .lp__contact-icon { width: 44px; height: 44px; background: var(--sky); border-radius: 10px; display: flex; align-items: center; justify-content: center; color: var(--ink); margin-bottom: 1rem; }
  .lp__contact-type { font-size: 0.65rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--muted); margin-bottom: 0.35rem; }
  .lp__contact-title { font-size: 1.05rem; font-weight: 700; color: var(--ink); }
  .lp__contact-num { font-size: 0.83rem; font-weight: 600; color: var(--sky-dark); margin-top: 0.5rem; font-family: 'DM Mono', monospace; }

  /* CTA */
  .lp__cta-section { background: var(--ink); padding: 5rem 3rem; display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 3rem; }
  .lp__cta-h2 { font-size: clamp(1.9rem, 3vw, 2.6rem); font-weight: 800; line-height: 1.15; color: var(--white); letter-spacing: -0.03em; }
  .lp__cta-h2 span { color: var(--sky); }
  .lp__cta-sub { font-size: 0.95rem; color: #94a3b8; margin-top: 0.75rem; line-height: 1.65; }
  .lp__cta-btns { display: flex; flex-direction: column; gap: 0.75rem; min-width: 210px; }
  .lp__cta-btn1 { display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; font-size: 0.8rem; font-weight: 700; background: var(--sky); color: var(--ink); border: none; padding: 0.9rem 1.75rem; border-radius: 8px; cursor: pointer; transition: background 0.2s; }
  .lp__cta-btn1:hover { background: var(--sky-dark); color: var(--white); }
  .lp__cta-btn2 { display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; font-size: 0.8rem; font-weight: 600; background: transparent; color: var(--white); border: 1.5px solid #334155; padding: 0.9rem 1.75rem; border-radius: 8px; cursor: pointer; transition: border-color 0.2s; }
  .lp__cta-btn2:hover { border-color: var(--sky); }

  /* FOOTER */
  .lp__footer { display: flex; justify-content: space-between; align-items: center; padding: 1.5rem 2.5rem; border-top: 1px solid var(--border); background: var(--white); flex-wrap: wrap; gap: 1rem; }
  .lp__footer-logo { font-weight: 800; font-size: 1rem; color: var(--ink); letter-spacing: -0.02em; }
  .lp__footer-logo span { color: var(--sky); }
  .lp__footer-copy { font-size: 0.72rem; color: var(--muted); }
  .lp__footer-links { display: flex; gap: 1.5rem; align-items: center; }
  .lp__footer-links a { font-size: 0.72rem; color: var(--muted); text-decoration: none; transition: color 0.2s; display: flex; align-items: center; }
  .lp__footer-links a:hover { color: var(--sky-dark); }

  /* RESPONSIVE */
  @media (max-width: 920px) {
    .lp__nav-links, .lp__nav-right { display: none; }
    .lp__hamburger { display: flex; }
    .lp__hero { grid-template-columns: 1fr; }
    .lp__hero-right { display: none; }
    .lp__feat-grid { grid-template-columns: 1fr; }
    .lp__app-inner { grid-template-columns: 1fr; }
    .lp__app-right { display: none; }
    .lp__dash-section { grid-template-columns: 1fr; }
    .lp__dash-left { border-right: none; border-bottom: 1px solid var(--border); }
    .lp__contact-section { grid-template-columns: 1fr; }
    .lp__contact-col { border-right: none; border-bottom: 1px solid var(--border); }
    .lp__contact-col:last-child { border-bottom: none; }
    .lp__cta-section { grid-template-columns: 1fr; gap: 2rem; }
    .lp__gallery-grid { grid-template-columns: repeat(2, 1fr); }
    .lp__footer { flex-direction: column; align-items: center; text-align: center; }
  }
`;

// ─────────────────────────────────────────────────────────────────────────────

const GOOGLE_PLAY =
  "https://play.google.com/store/apps/details?id=com.mohammad1998a.bokahitbusiness";
const APP_STORE = "https://apps.apple.com/us/app/bokahitbusiness/id6759691684";

const LANGUAGES = [
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
];

const MARQUEE_ITEMS = [
  "Smart Scheduling",
  "Client Management",
  "Analytics & Insights",
  "Push Notifications",
  "Works Offline",
  "Real-Time Sync",
  "Smart Scheduling",
  "Client Management",
  "Analytics & Insights",
  "Push Notifications",
  "Works Offline",
  "Real-Time Sync",
];

const PHONE_SLOTS = [
  { h: 52, bg: "#38bdf8", op: 0.75 },
  { h: 36, bg: "#1e3a5f", op: 1 },
  { h: 24, bg: "#1e3a5f", op: 1 },
  { h: 24, bg: "#1e3a5f", op: 1 },
  { h: 44, bg: "#38bdf8", op: 0.35 },
  { h: 24, bg: "#1e3a5f", op: 1 },
  { h: 36, bg: "#1e3a5f", op: 1 },
  { h: 20, bg: "#38bdf8", op: 0.55 },
];

// ─────────────────────────────────────────────────────────────────────────────

const LandingPage = () => {
  const { t, i18n } = useTranslation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeFeat, setActiveFeat] = useState(0);
  const [showLangModal, setShowLangModal] = useState(false);
  const [showLangDrop, setShowLangDrop] = useState(false);

  useEffect(() => {
    try {
      const visited = localStorage.getItem("hasVisited");
      const lang = localStorage.getItem("lang");
      if (!visited) {
        setShowLangModal(true);
      } else if (lang) {
        i18n.changeLanguage(JSON.parse(lang));
      }
    } catch {
      localStorage.removeItem("lang");
      localStorage.removeItem("hasVisited");
      setShowLangModal(true);
    }
  }, [i18n]);

  useEffect(() => {
    const id = setInterval(() => setActiveFeat((p) => (p + 1) % 3), 3000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const selectLang = (code) => {
    try {
      i18n.changeLanguage(code);
      localStorage.setItem("lang", JSON.stringify(code));
      localStorage.setItem("hasVisited", "true");
      setShowLangModal(false);
    } catch {
      /**/
    }
  };
  const changeLang = (code) => {
    try {
      i18n.changeLanguage(code);
      localStorage.setItem("lang", JSON.stringify(code));
      setShowLangDrop(false);
    } catch {
      /**/
    }
  };
  const scrollToApp = () => {
    document
      .getElementById("app")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
    setMobileOpen(false);
  };

  const currentLang =
    LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const features = [
    {
      icon: <IconCalendar s={22} />,
      title: t("SmartScheduling"),
      desc: t("SmartSchedulingDesc"),
      stat: t("SmartSchedulingStat"),
    },
    {
      icon: <IconUsers s={22} />,
      title: t("ClientManagement"),
      desc: t("ClientManagementDesc"),
      stat: t("ClientManagementStat"),
    },
    {
      icon: <IconBarChart s={22} />,
      title: t("AnalyticsInsights"),
      desc: t("AnalyticsInsightsDesc"),
      stat: t("AnalyticsInsightsStat"),
    },
  ];

  const benefits = [
    {
      icon: <IconClock s={18} />,
      title: t("SaveHoursDaily"),
      desc: t("SaveHoursDesc"),
    },
    {
      icon: <IconCheck s={18} />,
      title: t("NeverMissAppointment"),
      desc: t("NeverMissDesc"),
    },
    {
      icon: <IconZap s={18} />,
      title: t("InstantSetup"),
      desc: t("InstantSetupDesc"),
    },
    {
      icon: <IconTrend s={18} />,
      title: t("BoostRevenue"),
      desc: t("BoostRevenueDesc"),
    },
  ];

  const appFeats = [
    {
      icon: <IconTick s={14} />,
      title: t("RealTimeSync"),
      desc: t("RealTimeSyncDesc"),
    },
    {
      icon: <IconZap s={14} />,
      title: t("PushNotifications"),
      desc: t("PushNotificationsDesc"),
    },
    {
      icon: <IconTick s={14} />,
      title: t("WorksOffline"),
      desc: t("WorksOfflineDesc"),
    },
  ];

  const phoneSlotNodes = PHONE_SLOTS.map((s, i) => (
    <div
      key={i}
      style={{
        height: s.h,
        background: s.bg,
        opacity: s.op,
        borderRadius: 6,
        flexShrink: 0,
      }}
    />
  ));

  return (
    <>
      <style>{styles}</style>
      <div className="lp" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
        {/* Language Modal */}
        {showLangModal && (
          <div className="lp__modal-overlay">
            <div className="lp__modal">
              <div className="lp__modal-icon">
                <IconGlobe s={24} />
              </div>
              <h2 className="lp__modal-title">Welcome to Bokahit!</h2>
              <p className="lp__modal-sub">
                Select your preferred language to continue
              </p>
              <div className="lp__modal-opts">
                {LANGUAGES.map((l) => (
                  <button
                    key={l.code}
                    className="lp__modal-opt"
                    onClick={() => selectLang(l.code)}
                  >
                    <span className="lp__modal-opt-left">
                      <span style={{ fontSize: "1.4rem" }}>{l.flag}</span>
                      {l.name}
                    </span>
                    <IconArrow s={15} />
                  </button>
                ))}
              </div>
              <p className="lp__modal-hint">
                You can change this later from the menu
              </p>
            </div>
          </div>
        )}

        {/* Nav */}
        <nav className={`lp__nav${scrolled ? " lp__nav--scrolled" : ""}`}>
          <a href="#" className="lp__logo">
            Boka<span>hit</span>
          </a>
          <ul className="lp__nav-links">
            <li>
              <a href="#features">{t("Features")}</a>
            </li>
            <li>
              <a href="#app">{t("MobileApp")}</a>
            </li>
            <li>
              <a href="#benefits">{t("Benefits")}</a>
            </li>
            <li>
              <a href="#contact">{t("Contact") || "Contact"}</a>
            </li>
          </ul>
          <div className="lp__nav-right">
            <a
              href="https://www.instagram.com/neholtorem/"
              target="_blank"
              rel="noopener noreferrer"
              className="lp__social-btn"
              aria-label="Instagram"
            >
              <IconInstagram s={18} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61583627140017"
              target="_blank"
              rel="noopener noreferrer"
              className="lp__social-btn"
              aria-label="Facebook"
            >
              <IconFacebook s={18} />
            </a>
            <div className="lp__lang-wrap">
              <button
                className="lp__lang-btn"
                onClick={() => setShowLangDrop((p) => !p)}
              >
                <IconGlobe s={14} />
                <span>{currentLang.flag}</span>
                <span>{currentLang.name}</span>
              </button>
              {showLangDrop && (
                <div className="lp__lang-drop">
                  {LANGUAGES.map((l) => (
                    <button
                      key={l.code}
                      className={`lp__lang-opt${i18n.language === l.code ? " lp__lang-opt--active" : ""}`}
                      onClick={() => changeLang(l.code)}
                    >
                      <span style={{ fontSize: "1.1rem" }}>{l.flag}</span>
                      {l.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button className="lp__nav-cta" onClick={scrollToApp}>
              {t("GetStarted")}
            </button>
          </div>
          <button
            className="lp__hamburger"
            onClick={() => setMobileOpen((p) => !p)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <IconClose s={24} /> : <IconMenu s={24} />}
          </button>
        </nav>

        {/* Mobile menu */}
        <div
          className={`lp__mobile-menu${mobileOpen ? " lp__mobile-menu--open" : ""}`}
        >
          <a href="#features" onClick={() => setMobileOpen(false)}>
            {t("Features")}
          </a>
          <a href="#app" onClick={() => setMobileOpen(false)}>
            {t("MobileApp")}
          </a>
          <a href="#benefits" onClick={() => setMobileOpen(false)}>
            {t("Benefits")}
          </a>
          <a href="#contact" onClick={() => setMobileOpen(false)}>
            {t("Contact") || "Contact"}
          </a>
          <div className="lp__mobile-lang-label">Language</div>
          <div className="lp__mobile-lang-grid">
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                className={`lp__mobile-lang-btn${i18n.language === l.code ? " lp__mobile-lang-btn--active" : ""}`}
                onClick={() => {
                  changeLang(l.code);
                  setMobileOpen(false);
                }}
              >
                <span style={{ fontSize: "1.4rem" }}>{l.flag}</span>
                {l.name}
              </button>
            ))}
          </div>
          <button className="lp__mobile-cta" onClick={scrollToApp}>
            {t("GetStarted")}
          </button>
        </div>

        {/* Marquee */}
        <div className="lp__marquee">
          <div className="lp__mq-inner">
            {MARQUEE_ITEMS.map((item, i) => (
              <span key={i}>{item}</span>
            ))}
          </div>
        </div>

        {/* Hero */}
        <section className="lp__hero">
          <div className="lp__hero-left">
            <div className="lp__badge">
              <span className="lp__badge-dot" />
              {t("TrustedByProfessionals")}
            </div>
            <h1 className="lp__h1">
              {t("AppointmentManagement")}
              <br />
              <span>{t("Simplified")}</span>
            </h1>
            <p className="lp__hero-desc">{t("HeroDescription")}</p>
            <div className="lp__hero-btns">
              <button className="lp__btn-main" onClick={scrollToApp}>
                {t("StartFreeTrial")} <IconArrow s={15} />
              </button>
              <button className="lp__btn-ghost">{t("WatchDemo")}</button>
            </div>
            <div className="lp__hero-stats">
              {[
                { n: "10K+", l: t("ActiveUsers") },
                { n: "1M+", l: t("AppointmentsBooked") },
                { n: "99.9%", l: t("Uptime") },
                { n: "4.9★", l: t("UserRating") },
              ].map((s) => (
                <div className="lp__stat-cell" key={s.l}>
                  <div className="lp__stat-num">{s.n}</div>
                  <div className="lp__stat-lbl">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="lp__hero-right">
            <div className="lp__hero-right-label">{t("AvailableOnMobile")}</div>
            <div className="lp__phone-sm">
              <div className="lp__p-notch" />
              {phoneSlotNodes}
              <img
                src={Image1}
                alt=""
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: 0.85,
                  borderRadius: "1.85rem",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
            <div className="lp__store-pills">
              <a
                href={GOOGLE_PLAY}
                target="_blank"
                rel="noopener noreferrer"
                className="lp__store-pill"
              >
                <div
                  className="lp__store-pill-icon"
                  style={{ background: "#2e7d32" }}
                >
                  <IconGooglePlay s={16} />
                </div>
                <div>
                  <p>{t("GetItOnGooglePlay")}</p>
                  <strong>{t("GooglePlay")}</strong>
                </div>
              </a>
              <a
                href={APP_STORE}
                target="_blank"
                rel="noopener noreferrer"
                className="lp__store-pill"
              >
                <div
                  className="lp__store-pill-icon"
                  style={{ background: "#1565c0" }}
                >
                  <IconApple s={16} />
                </div>
                <div>
                  <p>{t("DownloadOnTheAppStore")}</p>
                  <strong>{t("AppStore")}</strong>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="lp__features-section">
          <div className="lp__section-label">{t("Features")}</div>
          <h2 className="lp__h2">
            {t("EverythingYouNeedTo")} <span>{t("Succeed")}</span>
          </h2>
          <p className="lp__section-sub">{t("BuiltForProfessionals")}</p>
          <div className="lp__feat-grid">
            {features.map((f, i) => (
              <div
                key={i}
                className={`lp__feat-card${activeFeat === i ? " lp__feat-card--active" : ""}`}
                onMouseEnter={() => setActiveFeat(i)}
              >
                <div className="lp__feat-icon-box">{f.icon}</div>
                <div className="lp__feat-title">{f.title}</div>
                <div className="lp__feat-desc">{f.desc}</div>
                <div className="lp__feat-stat">{f.stat}</div>
              </div>
            ))}
          </div>
        </section>

        {/* App Section */}
        <section
          id="app"
          className="lp__app-section"
          style={{ scrollMarginTop: "61px" }}
        >
          <div className="lp__app-inner">
            <div>
              <div className="lp__section-label">{t("AvailableOnMobile")}</div>
              <h2 className="lp__h2">
                {t("ManageEverything")} <span>{t("OnTheGo")}</span>
              </h2>
              <p className="lp__app-body">{t("MobileAppFullDescription")}</p>
              <div className="lp__app-feat-list">
                {appFeats.map((f, i) => (
                  <div className="lp__app-feat-row" key={i}>
                    <div className="lp__app-feat-dot">{f.icon}</div>
                    <div>
                      <div className="lp__app-feat-title">{f.title}</div>
                      <div className="lp__app-feat-desc">{f.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lp__app-right">
              <div className="lp__phone-lg">
                <div
                  style={{
                    width: 40,
                    height: 5,
                    background: "#1e3a5f",
                    borderRadius: 3,
                    alignSelf: "center",
                    marginBottom: 4,
                    flexShrink: 0,
                  }}
                />
                {phoneSlotNodes}
                <img
                  src={Image1}
                  alt=""
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: 0.85,
                    borderRadius: "2.35rem",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
              <div className="lp__dl-btns">
                <a
                  href={GOOGLE_PLAY}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp__dl-btn"
                >
                  <div
                    className="lp__dl-icon"
                    style={{ background: "#2e7d32" }}
                  >
                    <IconGooglePlay s={17} />
                  </div>
                  <div>
                    <p>{t("GetItOnGooglePlay")}</p>
                    <strong>{t("GooglePlay")}</strong>
                  </div>
                </a>
                <a
                  href={APP_STORE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp__dl-btn"
                >
                  <div
                    className="lp__dl-icon"
                    style={{ background: "#1565c0" }}
                  >
                    <IconApple s={17} />
                  </div>
                  <div>
                    <p>{t("DownloadOnTheAppStore")}</p>
                    <strong>{t("AppStore")}</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="lp__gallery">
            <div className="lp__gallery-title">{t("SeeItInAction")}</div>
            <div className="lp__gallery-grid">
              {[Image1, Image2, Image3, Image4].map((img, i) => (
                <div className="lp__gallery-item" key={i}>
                  <img src={img} alt={`Screenshot ${i + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits + Dashboard */}
        <section id="benefits" className="lp__dash-section">
          <div className="lp__dash-left">
            <div className="lp__section-label">
              {t("WhyProfessionalsChoose")}
            </div>
            <h2 className="lp__h2" style={{ fontSize: "2rem" }}>
              {t("WhyProfessionalsChoose")} <span>{t("NeholTorem")}</span>
            </h2>
            <p
              style={{
                fontSize: "0.93rem",
                color: "var(--muted)",
                lineHeight: 1.7,
              }}
            >
              {t("BenefitsDescription")}
            </p>
            <div className="lp__bene-grid">
              {benefits.map((b, i) => (
                <div className="lp__bene-card" key={i}>
                  <div className="lp__bene-icon">{b.icon}</div>
                  <div className="lp__bene-title">{b.title}</div>
                  <div className="lp__bene-desc">{b.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="lp__dash-right">
            <div className="lp__section-label">Live dashboard</div>
            <h3
              style={{
                fontSize: "1.2rem",
                fontWeight: 700,
                color: "var(--ink)",
              }}
            >
              Today's performance
            </h3>
            <div className="lp__dash-card">
              <div className="lp__dash-row">
                <div className="lp__dash-lbl">{t("TodaysAppointments")}</div>
                <div className="lp__dash-val lp__dash-val--green">24</div>
              </div>
              <div className="lp__dash-row">
                <div className="lp__dash-lbl">{t("ClientSatisfaction")}</div>
                <div className="lp__dash-val lp__dash-val--sky">4.9 ★</div>
              </div>
              <div className="lp__dash-row">
                <div className="lp__dash-lbl">{t("ThisMonthRevenue")}</div>
                <div style={{ textAlign: "right" }}>
                  <div className="lp__dash-val">$47,250</div>
                  <div className="lp__dash-badge">
                    {t("PercentageFromLastMonth")}
                  </div>
                </div>
              </div>
              <div className="lp__dash-row">
                <div className="lp__dash-lbl">{t("ActiveClients")}</div>
                <div className="lp__dash-val">156</div>
              </div>
              <div className="lp__dash-row">
                <div className="lp__dash-lbl">{t("ShowRate")}</div>
                <div className="lp__dash-val lp__dash-val--green">98%</div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="lp__contact-section">
          <a
            href="https://wa.me/46790205074"
            target="_blank"
            rel="noopener noreferrer"
            className="lp__contact-col"
          >
            <div className="lp__contact-icon">
              <IconWhatsApp s={22} />
            </div>
            <div className="lp__contact-type">WhatsApp</div>
            <div className="lp__contact-title">
              {t("ChatWithUs") || "Chat with us"}
            </div>
            <div className="lp__contact-num">+46 79 020 50 74</div>
          </a>
          <a href="tel:+46790205074" className="lp__contact-col">
            <div className="lp__contact-icon">
              <IconPhone s={22} />
            </div>
            <div className="lp__contact-type">{t("Phone") || "Phone"}</div>
            <div className="lp__contact-title">
              {t("CallUs") || "Call us directly"}
            </div>
            <div className="lp__contact-num">+46 79 020 50 74</div>
          </a>
          <a href="sms:+46790205074" className="lp__contact-col">
            <div className="lp__contact-icon">
              <IconSMS s={22} />
            </div>
            <div className="lp__contact-type">{t("SMS") || "SMS"}</div>
            <div className="lp__contact-title">
              {t("TextUs") || "Send us a text"}
            </div>
            <div className="lp__contact-num">+46 79 020 50 74</div>
          </a>
        </section>

        {/* CTA */}
        <div className="lp__cta-section">
          <div>
            <h2 className="lp__cta-h2">
              {t("ReadyToTransform")} <span>your business?</span>
            </h2>
            <p className="lp__cta-sub">{t("CTADescription")}</p>
          </div>
          <div className="lp__cta-btns">
            <button className="lp__cta-btn1" onClick={scrollToApp}>
              <IconDownload s={16} /> {t("DownloadApp")}
            </button>
            <button className="lp__cta-btn2" onClick={scrollToApp}>
              {t("StartFreeTrial")} <IconArrow s={15} />
            </button>
          </div>
        </div>

        {/* Footer */}
        <footer className="lp__footer">
          <div className="lp__footer-logo">
            Boka<span>hit</span>
          </div>
          <div className="lp__footer-copy">{t("CopyrightMainPage")}</div>
          <div className="lp__footer-links">
            <a href="#">{t("Privacy")}</a>
            <a href="#">{t("Terms")}</a>
            <a
              href="https://www.instagram.com/bokahitbusiness/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <IconInstagram s={16} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61576819842993"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <IconFacebook s={16} />
            </a>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;
